// Run this example by adding <%= javascript_pack_tag 'Qwizme' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Qwizme React</div> at the bottom
// of the page.

import React from "react";
import ReactDOM from "react-dom";

import Signup from "../src/components/Signup/Signup";
import { Provider } from "react-redux";
import store from "../src/dux/global/configureStore";

// ES module-style import
import bugsnag from "@bugsnag/js";
import bugsnagReact from "@bugsnag/plugin-react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

library.add(faTimes);

var bugsnagClient = bugsnag(process.env.QWIZME_BUGSNAG_API_KEY);

bugsnagClient.use(bugsnagReact, React);

var ErrorBoundary = bugsnagClient.getPlugin("react");

const AppWrapper = function() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <Signup />
      </Provider>
    </ErrorBoundary>
  );
};

// const root = document.getElementById();
const root = document.getElementById("signup");

ReactDOM.render(<AppWrapper />, root);
